/*
* function to update metrics to track how often
* the site preference prompt is triggered - US156667
*/

export const updateAnalyticsDataLayer = (data) => {
    if (window.metricsData && data) {
        window.metricsData.page.featuredContent = data;
    }
};

export const updateAnalyticsUserSummitTier = (tier) => {
    if (!Number.parseInt(tier, 10)) return;
    if (window.metricsData) {
        window.metricsData.user = window.metricsData.user || {};
        window.metricsData.user.clientTier = tier;
    }

    if (window && window.trpQualtrics) {
        const qD = {
            ...window.trpQualtrics,
            clientTier: tier
        };
        window.trpQualtrics = { ...qD };
    } else if (window) {
        window.trpQualtrics = { clientTier: tier };
    }
};
